import { getData } from 'helpers/apiHelper';
import { AUDIT_LOGS, MAIN_PATH } from './apiPath';
import { pickBy } from "lodash";

export function getAuditLogsList(payload) {
  let url = `${MAIN_PATH}${AUDIT_LOGS}`;
  let params = pickBy(payload)
  return getData(url, { params });
}
